/** Composants 3D chargés à la demande (studio web : découpage en morceaux par Vite). */
import { lazy } from "react";
import type { ThreeComponents } from "../blocks.js";
export const lazyThree: ThreeComponents = {
  Solid3D: lazy(() => import("./Solid3D.js")),
  Model3D: lazy(() => import("./Model3D.js")),
};
